import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useFormik } from 'formikV2';
import { useAuthenticateMutation, didSucceed, requiresChallenge } from './useAuthenticateMutation';
import { LoginSchema } from './validationSchema';
export var LOGIN_FORM_STATE;

(function (LOGIN_FORM_STATE) {
  LOGIN_FORM_STATE[LOGIN_FORM_STATE["success"] = 0] = "success";
  LOGIN_FORM_STATE[LOGIN_FORM_STATE["requiresChallenge"] = 1] = "requiresChallenge";
  LOGIN_FORM_STATE[LOGIN_FORM_STATE["failure"] = 2] = "failure";
  LOGIN_FORM_STATE[LOGIN_FORM_STATE["default"] = 3] = "default";
})(LOGIN_FORM_STATE || (LOGIN_FORM_STATE = {}));

var useLoginForm = function useLoginForm(userCreds) {
  var _useAuthenticateMutat = useAuthenticateMutation(),
      authenticateMutation = _useAuthenticateMutat.authenticateMutation,
      loading = _useAuthenticateMutat.loading;

  var _useState = useState(LOGIN_FORM_STATE["default"]),
      _useState2 = _slicedToArray(_useState, 2),
      result = _useState2[0],
      setResult = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var handleFormSubmission = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var email, password, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref.email, password = _ref.password;
              _context.next = 3;
              return authenticateMutation(email, password);

            case 3:
              data = _context.sent;

              if (didSucceed(data)) {
                setData(data);
                setResult(LOGIN_FORM_STATE.success);
              } else if (requiresChallenge(data)) {
                setData(data);
                setResult(LOGIN_FORM_STATE.requiresChallenge);
              } else {
                setResult(LOGIN_FORM_STATE.failure);
              }

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFormSubmission(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _useFormik = useFormik({
    initialValues: {
      password: userCreds.password,
      email: userCreds.email
    },
    onSubmit: handleFormSubmission,
    validateOnBlur: true,
    validateOnChange: false,
    validationSchema: LoginSchema
  }),
      errors = _useFormik.errors,
      handleChange = _useFormik.handleChange,
      handleSubmit = _useFormik.handleSubmit,
      values = _useFormik.values;

  return {
    errors: errors,
    data: data,
    handleChange: handleChange,
    handleSubmit: handleSubmit,
    loading: loading,
    result: result,
    values: values
  };
};

export { useLoginForm };